// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:34:10+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            dccd97b615daaaf18fa8fe92a0fcfb36
//    Signature:      eyJpdiI6IkIwMmtIQjJQM1dsalZLWU50TGdnakE9PSIsInZhbHVlIjoidVJoUEtCdFlsd2xSRWNadmdPRXBFMlh5MWFndTR1UWtUR0RHc0l6YmRrNlM3cGJleXZJNnY2d3UxYzVLQW56enBBSlJ1TDlsOTM4d1p6MzRiZGUrR1AzNVVoT1lVeTBHRnZjaGVnb0owTWpBUlh5TGR5Q25tWVZqaFczbWV4OE4xdVl5dmRLTFQ1akN3aG5CVElpaUk5dm5vM3RIK2dPZ2pIWmI0Mm14UEhvXC9BR3M5OWxmU1pNNysreVNIdmp0UWxaaUNNOVJ5dWhUdFVEWlErMjZiM012Zk91N3VVZVBJOUljakM3dWpiWStLc0R3Nng5ekk2THdHRU95VWZmVjBoQmVlV1A2cnpDajZpK0ZqWUVQMXNrTXBOck9KN29cL3NcL2dQQkxkYTBJOTZlK1BqMDVlaVhwSTBKRkpSN2tVeWM5OUVlU3lcL3dqUmlWZGY5d09RSFNkT1VoSENXeUdYWjFZYmJLZHVwQlJGUks2a0lCajlwSGQxT2VkdXZ0K0h5NytNZk5xV3djdXFuVytqdW9vNjZyb040MUVqQ09MWEtUQzhzS2pldlp5WTg9IiwibWFjIjoiNTViMjNiNTdkNjFhMTEwZjU3MDU4Y2UyYjQwM2NjZWFlOTAyYjI3ZjQzYjFmNWQ2OWQ5ZWJjZDFhNWI2OTM3MSJ9
$(document).ready(function () {
    let x=8;
    let to_show = 8;
    let size_li = $(".accordion-item.active").length;
    if (size_li > to_show) {
      $('.load-more-module').removeClass('hide')
    }
    let percentage = (x / size_li)*100;
    $('.fill').css('width', percentage+'%');
    $('.accordion-item.active:lt('+x+')').removeClass('hide');
    $('.accordion-item.active:lt('+x+')').addClass('active');
    $('#viewed-count').html(x)
    $('.loadMore').click(function () {
        x= (x+to_show <= size_li) ? x+to_show : size_li;
        $('#viewed-count').html(x)
        percentage = (x / size_li)*100;
        $('.fill').css('width', percentage+'%');
        $('.accordion-item.active:lt('+x+')').removeClass('hide');
        $('.accordion-item.active:lt('+x+')').addClass('active');
        if(x == size_li){
            $('.fill').css('width', '100%');
            $('.loadMore').hide();
        }
    });
  });
